import run from '../../utilities/run';
import $ from 'jquery';

run("#order-packaging-details", ()=>{
	const el = $("#order-packaging-details");
  	attachFunctionality(el);
});	

function attachFunctionality(el) {
	const pkgSlipPreviewBtn = el.find(".package-slip-preview");
	const cmlInvPreviewBtn = el.find(".commercial-invoice-preview");
	const imageLogoPreviewBtn = el.find(".imageLogoPreview");
	const rtlBrandImageLogo = el.find("#rtlBrandImageLogo");
	const rtlBrandLogoModalClose = el.find("#rtlBrandLogoModalClose");

	const pkgSlipPreviewUrl = el.data("package-slip-preview-url");
	const cmlInvPreviewUrl = el.data("commercial-invoice-preview-url");
	const imageLogoPreviewUrl = el.data("brand-logo-image-url");

	const orderPackagingDetails = el.data("order-package-details");

	$(pkgSlipPreviewBtn).on("click", function(e) {
		e.preventDefault();
		window.open(pkgSlipPreviewUrl,'window1');
	});

	$(cmlInvPreviewBtn).on("click", function(e) {
		e.preventDefault();
		window.open(cmlInvPreviewUrl,'window1');
	});

	$(rtlBrandImageLogo).on("click", function(e) {
		e.preventDefault();
		$("#rtlBrandLogoModal").modal("show");
	});

	$(rtlBrandLogoModalClose).on("click", function(e) {
		e.preventDefault();
		$("#rtlBrandLogoModal").modal("hide");
	});
}


// WEBPACK FOOTER //
// ./src/pages/orderpackaging/details.js